import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConstantsService } from "../../services/constants/constants.service";
import { OrganisationService } from "../../services/organisation/organisation.service";
import { EnvironmentService } from "../../services/environment/environment.service";
import { PermissionsService } from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-change-plan-modal',
  templateUrl: './change-plan-modal.component.pug',
  styleUrls: ['./change-plan-modal.component.scss'],
  standalone: false
})
export class ChangePlanModalComponent implements OnInit, OnDestroy {
  @Input() preSelectedPlan = '';
  @Input() billingPeriod = $localize`monthly`;
  @Input() selectedCurrency = 'USD';
  @Input() plans: any[] = [];
  @Output() planSelected = new EventEmitter<any>();
  showCurrencyDropdown = false;
  currencies = ['USD', 'AUD'];
  selectedPlan: string = '';
  planDescription = {
    'SS_Starter': $localize`Ideal for organisations with up to 75 employees`,
    'SS_Growth': $localize`Ideal for organisations with up to 150 employees`,
    'SS_Plus': $localize`Ideal for organisations with up to 300 employees`,
    'SS_Premium': $localize`Ideal for organisations with up to 500 employees`
  }

  constructor(
    private modalService: BsModalService,
    private organisationService: OrganisationService,
    private environmentService: EnvironmentService,
    public permissions: PermissionsService,
  ) {
  }

  ngOnInit(): void {
    this.selectedPlan = this.preSelectedPlan;
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', (event: MouseEvent) => {
      const dropdownContainer = document.querySelector('.currency-dropdown-container');
      if (dropdownContainer && !dropdownContainer.contains(event.target as Node)) {
        this.showCurrencyDropdown = false;
      }
    });
  }

  toggleCurrencyDropdown(): void {
    this.showCurrencyDropdown = !this.showCurrencyDropdown;
  }

  selectCurrency(currency): void {
    this.selectedCurrency = currency;
    this.showCurrencyDropdown = false;
    this.changeCurrency(currency);
  }

  changeCurrency(currency: 'USD' | 'AUD'): void {
    this.selectedCurrency = currency;
  }

  isPlanSelected(planName: string): boolean {
    return this.selectedPlan === planName;
  }

  getPlanClass(planName: string): string {
    return this.isPlanSelected(planName) ? 'signup-plan-toggle-selected' : 'signup-plan-toggle';
  }

  getLabelClass(planName: string): string {
    return this.isPlanSelected(planName) ? 'primary-label-text-selected' : 'primary-label-text';
  }

  getMonthTextClass(planName: string): string {
    return this.isPlanSelected(planName) ? '' : 'month-text-non-selected';
  }

  getCurrentPrice(plan: any): number {
    const prices = plan.item_prices.filter(price =>
      price.currency_display === this.selectedCurrency
    );

    const yearlyPrice = prices.find(p => p.frequency_display === 'yearly')?.price;
    return yearlyPrice ? Math.round((yearlyPrice / 12) * 100) / 100 : 0;
  }

  selectPlan(planName: string): void {
    this.selectedPlan = planName;
  }

  closeModal(): void {
    const payload = {
      audit_log: 'SIGNUP_PLAN_SELECTED',
      log: {
        previously_selected_plan: this.preSelectedPlan,
        current_selected_plan: this.selectedPlan
      }
    }
    this.organisationService.addAuditLog(payload)
    const selectedPlanDetails = this.plans.find(plan => plan.cb_name === this.selectedPlan);
    if (selectedPlanDetails) {
      const prices = selectedPlanDetails.item_prices.filter(price =>
        price.currency_display === this.selectedCurrency
      );

      this.planSelected.emit({
        name: selectedPlanDetails.cb_name,
        planUid: selectedPlanDetails.uid,
        planDescription: this.planDescription[selectedPlanDetails.cb_id],
        pricing: {
          monthly: prices.find(p => p.frequency_display === 'monthly')?.price || 0,
          yearly: prices.find(p => p.frequency_display === 'yearly')?.price || 0
        },
        currency: this.selectedCurrency,
        cbItemPriceId: prices.find(p => p.frequency_display === this.billingPeriod)?.cb_item_price_id || 0,
        profileCap: selectedPlanDetails.cb_meta.profile_cap
      });
    }
    this.modalService.hide();
  }

  redirectToContactUsPage() {
    window.open(ConstantsService.SIGNUP_CONTACT_XREF_URL, '_blank');
  }

  redirectToPricing() {
    window.open(this.environmentService.getPricingUrl(), '_blank');
  }

   // Listen for clicks anywhere on the document
  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown')) {
      this.showCurrencyDropdown = false;
    }
  }
}
